import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "18", r: "3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "6", cy: "6", r: "3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "18", cy: "6", r: "3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M18 9v1a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V9", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 12v3", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "GitFork";
const GitFork = memo(themed(Icon));
export {
  GitFork
};
//# sourceMappingURL=git-fork.js.map
